import React, { useEffect, useState } from "react";
import Carousel from "react-bootstrap/Carousel";

import { Electricity } from "../partials/Electricity";
import { NaturalGas } from "../partials/NaturalGas";
import { RenewablePower } from "../partials/RenewablePower";
import { CorporatePPA } from "../partials/CorporatePPA";
import { HydrogenForIndustry } from "../partials/HydrogenForIndustry";
import { CarbonCapture } from "../partials/CarbonCapture";
import { CarbonCredits } from "../partials/CarbonCredits";
import { Solar } from "../partials/Solar";
import { EnergyManagement } from "../partials/EnergyManagement";
import { DemandResponse } from "../partials/DemandResponse";
import { EMobility } from "../partials/EMobility";
import { HydrogenForTransport } from "../partials/HydrogenForTransport";
import { LNG } from "../partials/LNG";
import { Biofuels } from "../partials/Biofuels";
import { Bitumen } from "../partials/Bitumen";
import { MarineSolutions } from "../partials/MarineSolutions";
import { SAF } from "../partials/SAF";
//Success stories
import { Airports } from "../successstories/Airports";
import { ChargingSites } from "../successstories/ChargingSites";
import { CorporateCampus } from "../successstories/CorporateCampus";
import { GreenEnergyGeneration } from "../successstories/GreenEnergyGeneration";
import { IndustrialSites } from "../successstories/IndustrialSites";
import { LogisticsHub } from "../successstories/LogisticsHub";
import { MobilityHub } from "../successstories/MobilityHub";
import { Ports } from "../successstories/Ports";
import { Residential } from "../successstories/Residential";
import { Stadium } from "../successstories/Stadium";



function CarouselHack({ cn, ind }) {

  const [index, setIndex] = useState(0);

  const handleSelect = (selectedIndex, e) => {
    stopVideo();
    setIndex(selectedIndex);
  };

  const handleNext = () => {
    let maxIndex = PartialContent.length - 1;
    let nextIndex = index + 1;
    
    if (nextIndex <= maxIndex) {
      stopVideo();
      setIndex(nextIndex);
    }
  };

  const handlePrev = () => {
    let prevIndex = index - 1;

    if (prevIndex >= 0) {
      stopVideo();
      setIndex(prevIndex);
    }
  };

  const stopVideo = () => {
    let thisVideo = document.querySelector('.active.carousel-item video');
    if(thisVideo !== null)
    {
      thisVideo.pause();
      thisVideo.currentTime = 0;
    }
  };

  useEffect(() => {
    setIndex(0);
  }, [cn]);

  useEffect(() => {
    console.log(ind);
    setIndex(ind);
  }, [ind]);

  const components = {
    electricity: Electricity,
    natural_gas: NaturalGas,
    renewable_power: RenewablePower,
    corporate_ppa: CorporatePPA,
    hydrogen_for_industry: HydrogenForIndustry,
    carbon_capture: CarbonCapture,
    carbon_credits: CarbonCredits,
    solar: Solar,
    energy_management: EnergyManagement,
    demand_response: DemandResponse,
    e_mobility: EMobility,
    hydrogen_for_transport: HydrogenForTransport,
    lng_and_gtl: LNG,
    biofuels: Biofuels,
    bitumen: Bitumen,
    marine_solutions: MarineSolutions,
    saf: SAF,
    //Success stories vvvv
    airport: Airports,
    charging_site: ChargingSites,
    corporate_campus: CorporateCampus,
    green_energy: GreenEnergyGeneration,
    industrial_sites: IndustrialSites,
    logistics_hub: LogisticsHub,
    mobility_hub: MobilityHub,
    ports: Ports,
    residential: Residential,
    stadium: Stadium
    
  }

  let PartialContent = components[cn];
  let cnDot = 'dots-' + PartialContent.length;
  //console.log(cnDot);

  return (
    <Carousel activeIndex={index}
      onSelect={handleSelect}
      controls={false}
      indicators={false}
      interval={null}
      wrap={false}
      fade={true}
      
    >
      {PartialContent.map((x, i) => (
        <Carousel.Item key={i}>
          {x}
        </Carousel.Item>
      ))}
      {PartialContent.length > 1 &&
      <div className="carousel-indicators">
      <button type="button" aria-label="Previous slide" className="slideArrow previousSlide icon--backward" aria-current="false" onClick={handlePrev} ></button>
      {PartialContent.map((x, i) => (
        <button
          type="button"
          data-bs-target=""
          aria-label={"Slide " + i}
          className={"pagination" + " " + (i === index ? "active" : "")}
          aria-current={i === index ? "true" : "false"}
          onClick={() => handleSelect(i)}
        >

        </button>
      ))}
      <button type="button" aria-label="Next slide" className="slideArrow nextSlide icon--forward" aria-current="false" onClick={handleNext}></button>
    </div>
      }
      
    </Carousel>


  );
}

export default CarouselHack;
